export class OrganisationsFilterDto {
    name: string = '';
    code: string = '';
    address: string = '';
    city: string = '';
    postcode: string = '';
    showDeactivated: boolean = false;
    showDeleted: boolean = false;
}
